import { render, staticRenderFns } from "./remarks-modal.vue?vue&type=template&id=974177a6&"
import script from "./remarks-modal.vue?vue&type=script&lang=js&"
export * from "./remarks-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports